<template>
  <div class="tableFrom">
    <div class="tableBox">
      <el-table ref="multipleTable"   :data="tableData" :highlight-current-row="true" tooltip-effect="dark"
          @selection-change="handleSelectionChange" @row-click="rowClick" :fit="true"
        :cell-style="cellStyle" :show-header="true" v-loading="columObj.loading" :row-class-name="tableRowClassName"
        :cell-class-name="tableCellClassName">
        <!-- 选择框是否开启，selectable是否单行禁用 -->
        <el-table-column class-name="selectionClass" v-if="columObj.selection" type="selection" :align="'left'"
          :selectable="columObj.selectable" width="60" />
        <!-- 序号 -->
        <!-- <el-table-column v-if="columObj.serialNumber" type="index" label="序号" :align="columObj.align || 'left'"
        width="100"></el-table-column> -->
        <el-table-column class-name="sn" v-if="columObj.serialNumber" type="index" label="序号"
          :align="columObj.align || 'left'" width="100">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"></span>
          </template>
        </el-table-column>
        <!-- 普通列 -->
        <el-table-column v-for="(column,columIndex) in columObj.tableHeader" :key="columIndex" :prop="column.prop"
          :label="column.label" :width="column.width" :fixed="column.fixed"
          :align="column.align || (column.isOperation ? 'center' : 'left')" :sortable="column.sortable"
          :index="columIndex" show-overflow-tooltip>
          <template slot-scope="{row,$index}">
            <template v-if="(column.prop == 'name'  || column.prop =='description') && (row.isAdd || row.isEdit)">
              <el-input maxlength="50" v-model="row[column.prop]" :disabled="column.isDisabled(row,$index)" placeholder=""></el-input>
            </template>
            <template v-if="column.select">
              <el-select v-model="row[column.prop]" :disabled="column.isDisabled(row,$index)" placeholder=""
                @change="((text) => { row['name'] = '' })">
                <el-option v-for="item in columObj.options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
            <template v-if="column.prop == 'manager_name' && (row.isAdd || row.isEdit)">
              <el-autocomplete :disabled="column.isDisabled(row,$index)" v-model="row[column.prop]"
                @input="changeMerName($event,row)"
                :fetch-suggestions="((queryString,callback) => {querySearchAsync(queryString,callback,column.label,row)})"
                placeholder="请输入内容" @select="selectSpecName($event,row)"  ></el-autocomplete>
            </template>
            <!-- 默认展示 -->
            <span v-if="!row.isEdit && !row.isAdd&&column.text  && column.editRow != $index"
              :style="{color:row[column.colorName]}">{{row[column.prop] || (row[column.prop] ==0 ? '-':'- -' ) }}</span>
            <!-- 自定义内容 -->
            <span v-if="column.ownDefined">{{column.ownDefinedReturn(row,$index)}}</span>
            <!-- 图片展示 -->
            <template>
              <el-popover trigger="hover" placement="top" popper-class="popper">
                <img class="popimg" v-if="column.image" :src="row[column.prop]" alt />
                <el-image slot="reference" v-if="column.image" :src="row[column.prop]" class="popimg" />
              </el-popover>
            </template>
            <!-- 操作按钮 -->
            <template v-if="column.isOperation">
              <span class="el-table-button" v-for="(operations, index) in column.operation" :key="index">
                <el-button v-if="operations.isShow(row,$index)" :disabled="operations.isDisabled(row,$index)"
                  :icon="operations.icon" :type="operations.type"
                  @click="operations.buttonClick(row,colIndex, $index,operations.state)"
                  :style="{color:operations.isDisabled(row,$index)?'':operations.color,background:operations.isDisabled(row,$index)?'':operations.background}"
                  :size="operations.size || 'mini'" :plain="operations.plain">
                  {{operations.label}}
                </el-button>
              </span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <template v-if="!columObj.hidePage"> -->
    <div class="page_div" v-if="pageObj.pageData !=null" :style="{textAlign: pageObj.position || 'left'}">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageObj.pageData.page" :pager-count="7" :page-sizes="[10, 15, 20, 30,50]"
        :page-size="pageObj.pageData.size" layout="total, sizes, prev, pager, next, jumper" :total="pageObj.total">
      </el-pagination>
    </div>
    <!-- </template> -->
  </div>
</template>

<script>
  import {
    ajax
  } from "@/api/jqajax";
  export default {
    props: {
      tableData: {
        type: Array,
        required: true
      },
      columObj: {
        type: Object,
        required: true
      },
      pageObj: {
        type: Object,
        required: true
      },
      colIndex: {
        type: Number,
      },
      setHeight: {
        default: ''
      },
      tableCellClassName: {
        type: Function
      }
    },
    data() {
      return {
        height: 420,
      }
    },
    created() {
      if (this.setHeight) {
        this.height = this.setHeight
      }
    },
    methods: {
      changeMerName(v,row){
        row.manager_id = null
      },
      getIndex($index) {
        return (this.pageObj.pageData.page - 1) * this.pageObj.pageData.size + $index + 1
      },
      // 帮助点击行，获取点击的下标
      tableRowClassName({
        row,
        rowIndex
      }) {
        row.rowIndex = rowIndex;
        if (rowIndex % 2 == 1) {
          return 'zebra-row';
        }
      },
      cellStyle(row) {
        // 状态列字体颜色
        if (row.row.docentSource === 0 && row.columnIndex === 6) {
          return {
            'color': '#145A45',
          };
        } else if (row.row.docentSource === 1 && row.columnIndex === 6) {
          return {
            'color': '#4287D3',
          };
        } else if (row.row.docentSource === 2 && row.columnIndex === 6) {
          return {
            'color': '#A5864D',
          };
        } else {
          return {
            'color': 'rgba(0, 0, 0, 0.92)',
          };
        }
      },
      // 点击行
      rowClick(row, column, event) {
        this.$emit("rowClick", row, column, event);
      },
      // 条数变化
      handleSizeChange(e) {
        this.$emit('handleSizeChange', e);
      },
      // 页码变化
      handleCurrentChange(e) {
        this.$emit('handleCurrentChange', e);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.$emit("SelectionChange", this.multipleSelection);
      },

      querySearchAsync(queryString, cb, name, row) {
        if(queryString == null ||queryString == "" || queryString.replace(/^\s+|\s+$/g, '') == "") {
          cb([]);
          return
        }
        ajax('get', {
          page: 1,
          per_page: 10,
          keyword:queryString
        }, "admin/member", (res) => {
          if (res.error_code == '0') {
            // res.data.data.fil
            var list = res.data.data.map(obj => {
              var v = obj.name
              var d = obj.id
              return {
                value: v,
                id: d
              }
            })
            cb(list);
            // row.optionsList = res.data.data;
          }
        })
      },
      selectSpecName(eve, row) {
        row.manager_id = eve.id
      }
    }
  }
</script>

<style lang="scss">
  .tableFrom {
    margin-top: 20px;
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;

    .tableBox {
      width: 100%;
      height: 100%;
      overflow-y: hidden;
    }

    .el-table {
      width: 100%;
      height: 100%;
      border: 1px solid #DEDEDE;
      border-bottom: none;

      .selectionClass,
      .sn {
        .cell {
          padding-left: 20px !important;
        }
      }

      thead {
        tr {
          line-height: 50px;
          box-sizing: border-box;

          th {
            padding: 0;
            font-weight: normal;
            color: RGBA(0, 0, 0, .6);
            background-color: #F3F3F3;
            // &.el-table__cell.is-leaf {
            //   border-top: 1px solid #DEDEDE;
            // }
          }
        }
      }

      .el-table__body {
        tr {

          &.el-table__row--striped td.el-table__cell {
            // background: #F3F3F3;
          }

          &:hover>td.el-table__cell {
            background-color: rgba(#0F5B45, .08);
          }

          &.current-row>td.el-table__cell {
            // background-color: #f3f3f3;
          }
        }
      }

      .el-checkbox {
        .el-checkbox__input {

          .el-checkbox__inner {
            width: 20px;
            height: 20px;
            border-color: #DEDEDE;

            &::before {
              top: 7px;
            }

            &::after {
              width: 5px;
              height: 9px;
              position: absolute;
              left: 0;
              right: 0;
              top: 2px;
              margin: auto;
            }
          }

          &.is-checked,
          &.is-indeterminate {
            .el-checkbox__inner {
              border-color: #0F5B45;
            }
          }
        }
      }

      .popimg {
        width: 100px;
        height: 100px;
        background: rgba(56, 118, 180, 0.08);
        border-radius: 50%;
        display: block;
        // margin: auto;
      }

      .el-image__error {
        font-size: 14px;
      }

      .el-table-button {
        &+.el-table-button {
          .el-button {
            margin-left: 10px;
          }
        }
      }

    }

    .page_div {
      flex-shrink: 0;
      margin-top: 20px;

      .el-pagination {
        padding: 0;
        margin-top: 40px;
        span,
        input,
        li,
        i,
        .btn-prev {
          color: RGBA(0, 0, 0, .92);
          font-weight: normal;
          height: 31px;
          line-height: 30px;
        }

        button:disabled {
          background-color: transparent;
        }

        .el-pager li {
          background-color: transparent;

          &.active {
            color: #F0A340;
          }
        }
      }



    }

  }


  // 隐藏滚动条
  // .el-table__body-wrapper {
  //   &::-webkit-scrollbar {
  //     // 整个滚动条
  //     width: 0; // 纵向滚动条的宽度
  //     background: rgba(213, 215, 220, 0.3);
  //     border: none;
  //   }

  //   &::-webkit-scrollbar-track {
  //     // 滚动条轨道
  //     border: none;
  //   }
  // }




  .el-tooltip__popper {
    max-width: 30%;
    padding-bottom: 5px;
    padding-top: 5px;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 11;
    -webkit-box-orient: vertical;

  }
</style>



// WEBPACK FOOTER //
// src/components/MyCbTable.vue